import { Card, Col, Row } from "antd";
import React from "react";
import { WarehouseCard } from "../../interface";
import NumberFormat from "react-number-format";

const CardTotal: React.FC<WarehouseCard> = (props) => (
  <Card title={props.title} bordered={false}>
    {Intl.NumberFormat().format(props.sum)}
  </Card>
);

export default CardTotal;
